// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1iANZ","item":"PaymentsMobile_item__1JCZh","label":"PaymentsMobile_label__2qOmb","amount":"PaymentsMobile_amount__2iugH"};